export const tableModel = item => {
    const value = item || {};

    return {
        name: value.title || "",
        id: value.id || null,
    };
};